import { format, formatDistanceToNowStrict, isToday, isTomorrow } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { IconTime, Text, tokens } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { CHECKOUT_DELIVERY_ETA } from '@fhs-legacy/frontend/src/utils/test-ids';

const DEFAULT_DELIVERY_MINUTES = 40;

export default function DeliveryEta() {
  const { serverOrder } = useCartContext();

  const maxDeliveryTime = serverOrder?.delivery?.dropoff.beforeTime || '';

  const { formattedTime, eta } = useMemo(() => {
    // Calculate delivery date & time from serverOrder or default to 40 minutes
    const formattedDateTime = maxDeliveryTime
      ? new Date(maxDeliveryTime)
      : new Date(Date.now() + DEFAULT_DELIVERY_MINUTES * 60 * 1000);

    // Format the order time
    const time = format(formattedDateTime, 'h:mm a');
    let displayTime: string;
    if (isToday(formattedDateTime)) {
      displayTime = `Today at ${time}`;
    } else if (isTomorrow(formattedDateTime)) {
      displayTime = `Tomorrow at ${time}`;
    } else {
      displayTime = `${format(formattedDateTime, 'eee')} at ${time}`;
    }

    const relativeTime = formatDistanceToNowStrict(formattedDateTime, { locale: enUS });

    return { formattedTime: displayTime, eta: relativeTime };
  }, [maxDeliveryTime]);

  return (
    <View testID={CHECKOUT_DELIVERY_ETA} style={[styles.linkSection, styles.sectionBorder]}>
      <View style={[styles.section]}>
        <View style={[styles.iconCircle]}>
          <IconTime size={24} />
        </View>

        <View style={{ flex: 1 }}>
          <Text.Ui size="xs">Estimated Delivery Time:</Text.Ui>
          <Text.Ui style={styles.marginBottom4} size="md" weight="bold">
            {formattedTime}
          </Text.Ui>
          <Text.Ui style={styles.marginBottom4} size="md" weight="bold">
            ~{eta}
          </Text.Ui>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  linkSection: {
    width: '100%',
  },
  section: {
    width: '100%',
    gap: 8,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  sectionBorder: {
    width: '100%',
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
  },
  marginBottom4: {
    marginBottom: 4,
  },
});
